'use strict';

var ServiceDemandNumberOfStopsFilterFactory = function ServiceDemandNumberOfStopsFilterFactory(DataFilter) {
  function ServiceDemandNumberOfStopsFilter() {
    DataFilter.call(this, 'service', 'numberOfStops');
  }
  ServiceDemandNumberOfStopsFilter.constructor = ServiceDemandNumberOfStopsFilter;
  ServiceDemandNumberOfStopsFilter.prototype = Object.create(DataFilter.prototype);
  ServiceDemandNumberOfStopsFilter.prototype.groupBy = 'numberOfStops';
  ServiceDemandNumberOfStopsFilter.prototype.filter = function (data, range) {
    var filteredData = [];
    if (Array.isArray(range) && range.length >= 1) {
      for (var i = 0; i < data.length; ++i) {
        if (data[i]) {
          for (var j = 0, rangeLen = range.length; j < rangeLen; ++j) {
            if (parseInt(data[i][this.groupBy]) === parseInt(range[j])) {
              filteredData.push(data[i]);
              break;
            }
          }
        }
      }
    }
    return filteredData;
  };
  return ServiceDemandNumberOfStopsFilter;
};
ServiceDemandNumberOfStopsFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ServiceDemandNumberOfStopsFilterFactory;